<template>
  <div class="groupCenter clearfix">
    <div class="titleBox">
      <h2>组合促销</h2>
      <p>我们提供电脑音乐设备，数码乐器，数字音频及相关领域产品！</p>
    </div>
    <div class="searchBox">
      <div class="form-group m-0">
        <label>组合名称</label>
        <input @input="initData(true)" v-model="keywordVal" type="text" class="form-control">
      </div>
    </div>
    <div class="jiazaiBox" v-if="intLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="!intLoading" class="threeBox">
        <div class="groupBox" v-for="app in data" :key="app.id" @click="showModelBox('group',app.id)">
          <div class="infoBox">
            <h4 class="huanchongKuai clearfix">
              {{app.title}}
            </h4>
            <p class="d-block d-sm-none price">
              <span v-if="app.countObj.zengsong*1!==0" class="badge badge-primary">买{{app.countObj.must}}赠{{app.countObj.zengsong}}</span>
              <span class="badge badge-primary" v-if="app.priceType==='1'">￥{{app.total_amount}}</span>
            </p>
            <p class="mb-2">
              {{app.tagline}}
            </p>
            <p class="content m-0">
              <span>{{app.startTime}} 至 {{app.endTime}}</span>
            </p>
          </div>
          <div class="imgBox text-primary">
            <div>
              <span v-if="app.countObj.zengsong*1!==0" class="badge badge-primary"><small>买 </small>{{app.countObj.must}}<small> 赠 </small>{{app.countObj.zengsong}}</span>
              <span class="badge badge-primary" v-if="app.priceType==='1'"><small>￥</small>{{app.total_amount}}</span>
            </div>
          </div>
        </div>
      <div class="col-12 text-center description">
        <br>
        <br>
        <div v-if='isLoading && page!==1' class='dynamicMessage'>
          <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
        </div>
        <div v-if='isNodata' class='dynamicMessage'>
          — 没有更多了 —
        </div>
        <div v-if='isError' class='dynamicMessage'>
          — 请求失败 —
        </div>
        <br>
        <br>
        <br>
      </div>
    </div>
    <transition leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowRightBox" class="rightBoxModel huanchong" @click.self="closeRightBoxFun">
        <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
          <component :closeRightBoxFun="closeRightBoxFun" :parameter="parameter" :is="isCompnentElement"></component>
        </transition>
        <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
          <span class="guanbiBtn cursor huanchongKuai" @click="closeRightBoxFun(false)">
            <i class="iconfont icon-icon-arrow-right2"></i>
          </span>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import commons from '@/util/commons';
import uiProductContent from '@/components/product/Content';
import uiGroupContent from '@/components/group/Content';

export default {
  name: 'groupCenter',
  mixins: [generalMix],
  data () {
    return {
      isShowRightBox: false,
      isCompnentElement: '',
      parameter: {},
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      // 筛选
      keywordVal: '',
      // 分页
      data: [], // 数据队列
      allPage: 1, // 总页数
      allNumber: 0,
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      intLoading: true // 初始化加载
    }
  },
  computed:{
    whereObj() {
      return {
        page: this.page,
        keyword: this.keywordVal
      };
    }
  },
  methods:{
    closeRightBoxFun() {
      this.isShowRightBox = false;
      this.parameter = {};
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
    },
    showModelBox(type,id) {
      this.parameter = {token:id};
      if(type === 'group'){
        this.isCompnentElement = 'ui-group-content';
      }else{
        this.isCompnentElement = 'ui-product-content';
      }
      $('html').addClass('scrollHide');
      this.isShowRightBox = true;
    },
    // 收藏
    collectFun(id) {
      // EventBus.$emit('globalLoadingFun', { bool: true,loading:true });
      resultCommons.apiDealercollectenter(this,{token:id}).then(app=>{
        if(app.state === 200){
          const info = this.data.find(ob=>{
            return ob.id === id;
          });
          info.collect = app.data.bool;
          this.$message.showMsgBox({
            type: 'success',
            content: app.message
          });
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message
          });
        }
        // EventBus.$emit('globalLoadingFun', { bool: false,loading:false });
      });
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
      }
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = commons.scrollToButton() <= 150;
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          resultCommons.apiGoodsgrouplistsall(that, this.whereObj).then((ob) => {
            console.log(ob, this.page);
          });
        }
      };
    },
    initData(bool = false){
      if(bool){
        this.intLoading = true;
      }
      // 执行搜索
      this.loadingFun(2);
      // 初始化
      this.data = [];
      this.allPage = 1;
      this.page = 1;
      // 不为空
      this.is_empty = false;
      const whereJson = this.whereObj;
      // 执行搜索
      return resultCommons.apiGoodsgrouplistsall(this, whereJson).then((ob) => {}).then(app=>{
        if(bool){
          this.intLoading = false;
        }
      });
    }
  },
  components: {
    'ui-product-content':uiProductContent,
    'ui-group-content':uiGroupContent
  },
  created() {
    // 主数据
    this.initData(true).then(app=>{});
  },
  mounted() {
    // 下拉事件
    this.scroll(this, window);
    $('html').removeClass('scrollHide');
  },
  beforeDestroy() {
    // 清除事件
    window.onscroll = null;
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.groupCenter {
  min-height: 120vh;
  .titleBox {
    margin-top: 30px;
    color: #FFFFFF;
    margin-bottom: 30px;
    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  div.searchBox{
    margin-bottom: 20px;
    display: flex;
    .form-group{
      flex: 1;
      width: 100%;
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background:#E9ECEF url("/static/images/staticsimg.jpg") no-repeat center center;
    background-size: cover;
    min-height: 90vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
    }
  }
  div.threeBox {
    min-height: 90vh;
    background: url("/static/images/staticsimg.jpg") no-repeat center center;
    background-size: cover;
    border-radius: 5px;
    overflow: hidden;
    padding:15px;
    /*background:#FFFFFF;*/
    div.groupBox{
      padding-top: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #E5E5E5;
      color: #000000;
      position: relative;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      &:last-child{
        border: 0;
      }
      &:hover{
        h4{
          color: #007BFF;
        }
      }
      div.infoBox{
        flex: 1;
        h4{
          font-size: 18px;
        }
        p.price{
          color: #FF5630;
          font-size: 18px;
          text-align: right;
          font-weight: bold;
        }
        div.tages{
          span{
            display: inline-block;
            margin-right: 0;
            line-height: 2em;
            padding:0 15px;
            border-radius: 5px;
            font-weight: normal;
            &:last-child{
              margin: 0;
            }
          }
        }
        div.price{
          i{
            font-size: 28px;
            color: #FF5630;
          }
        }
      }
      div.imgBox{
        display: flex;
        justify-content: end;
        align-items: center;
        width: 300px;
        border-radius: 5px;
        font-weight: bold;
        font-size: 22px;
        border-left: 1px solid #E5E5E5;
        small{
          font-weight: bold;
          font-size: 0.7em;
        }
      }
    }
    div.col-12{
      margin-bottom: 20px;
    }
  }
  div.loadingBox{
    margin-bottom: 60px;
    margin-top: 40px;
    div.noDataBox{

    }
  }
}

@media (max-width: 992px) {
  .homeCenter{
    .titleBox {
      margin-top: 30px;
      color: #333333;
      margin-bottom: 30px;

      p {
        margin: 0;
        color: #999999;
      }
    }
  }
}

@media (max-width: 767px) {
  .groupCenter{
    .titleBox {
      margin-top: 50px;
      text-align: center;
      p{
        padding: 0 15px;
      }
    }
    div.searchBox{
      flex-direction: column-reverse;
      div.box{
        margin-right: 0;
        margin-bottom: 10px;
        &:last-child{
          button.btn{
            width: 100%;
          }
        }
      }
    }
    div.threeBox {
      div.groupBox{
        padding-bottom: 5px;
        div.imgBox{
          display: none;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/group/Index.vue